import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Tooltip,
  Heading,
  Box,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { Flex, IconButton, Text } from "@chakra-ui/react";
import { FaXmark } from "react-icons/fa6";
import { useSelector, useDispatch } from "react-redux";
import IsSending from "./partials/IsSending";
import { sendTreatmentPlanEmail } from "../../actions/treatmentPlanActions";
import AddTreatmentPlanModal from "./AddTreatmentPlanModal";
import SelectSenderIdentityModal from "./SelectSenderIdentityModal";
import { TREATMENTPLAN_SEND_EMAIL_RESET } from "../../constants/treatmentPlanConstants";
import TreatmentPlanHeaderPublic from "../partials/treatmentplans/TreatmentPlanHeaderPublic";
import TreatmentPlanServicesPublic from "../partials/treatmentplans/TreatmentPlanServicesPublic";
import TreatmentPlanClinicHeaderPublic from "../partials/treatmentplans/TreatmentPlanClinicHeaderPublic";
import TreatmentPlanSendingPatient from "../partials/treatmentplans/TreatmentPlanSendingPatient";
// import TreatmentPlanSendingSenderIdentity from "../partials/treatmentplans/TreatmentPlanSendingSenderIdentity";
import TreatmentPlanSendingPatientPortalInfo from "../partials/treatmentplans/TreatmentPlanSendingPatientPortalInfo";
import { getPatientDetailsAction } from "../../actions/patientActions";
// import LanguageButtonMain from "../../components/buttons/LanguageButtonMain";
// import FormControlCountry from "../input/FormControlCountry";
// import FormControlLanguage from "../input/FormControlLanguage";
import TreatmentPlanPreviewPatientNotes from "../partials/treatmentplans/TreatmentPlanPreviewPatientNotes";
import TreatmentPlanPreviewFooter from "../partials/treatmentplans/TreatmentPlanPreviewFooter";
import { useParams } from "react-router-dom";

const SendTreatmentPlanModalNew = ({
  treatmentPlan,
  // PROPS
  planId,
  planID,
  open,
  setOpen,
  patient,
  isModalSending,
  setIsModalSending,
  fetchUserDetails,
  fetchUnavailable,
  setFetchUnavailable,
  close,
  hasAccessSendToPatient,
}) => {
  const { slug } = useParams();
  const { t } = useTranslation();

  // STATE
  const [isSending, setIsSending] = useState(false);
  const [sender, setSender] = useState(null);

  const [selectedPlans, setSelectedPlans] = useState([]);
  const [planNumber, setPlanNumber] = useState(null);

  const [addTreatmentPlanModalOpen, setAddTreatmentPlanModalOpen] =
    useState(false);
  const [addSenderIdentitiesModalOpen, setAddSenderIdentitiesModalOpen] =
    useState(false);

  const [planTextLanguage, setPlanTextLanguage] = useState("");

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { tenant } = tenantDetailsBySlug;

  const treatmentPlanSendEmail = useSelector(
    (state) => state.treatmentPlanSendEmail
  );
  const {
    loading: loadingSendEmail,
    error: errorSendEmail,
    success: successSendEmail,
  } = treatmentPlanSendEmail;

  // HANDLERS

  const closeHandler = () => {
    // console.log("overlay clicked");
    if (!isModalSending) {
      // console.log("not sending");
      setOpen(false);

      // console.log("isModalsending false and closing");

      if (successSendEmail || errorSendEmail) {
        // console.log("successSend Email or error");

        close();

        dispatch(getPatientDetailsAction(patient._id, slug));

        dispatch({ type: TREATMENTPLAN_SEND_EMAIL_RESET });
      }
    } else if (isModalSending) {
      // console.log(" sending");
    }
  };

  const handlePlanSelect = (updatedPlans) => {
    if (!Array.isArray(updatedPlans)) {
      return;
    }

    // Update the state
    setSelectedPlans(updatedPlans);
  };

  const handleSenderSelect = (selectedSender) => {
    setSender(selectedSender);
  };

  const handleSendTreatmentPlanListEmail = () => {
    setIsSending(true);
    dispatch(
      sendTreatmentPlanEmail(
        slug,
        sender,
        tenant,
        planTextLanguage,
        selectedPlans,
        patient._id
      )
    );
  };

  // USE EFFECT

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    const initialLanguage = storedLanguage || "lt";
    setPlanTextLanguage(initialLanguage);
  }, []);

  useEffect(() => {
    if (planId) {
      setSelectedPlans((prevPlans) => {
        // Check if the plan is already in the list
        const alreadyExists = prevPlans.some((plan) => plan._id === planId);
        if (alreadyExists) return prevPlans; // Don't re-add

        return [
          ...prevPlans,
          { _id: planId, treatmentPlanID: planID || "Unknown Plan ID" },
        ];
      });
    }
    // Run this only when modal opens (planId changes), not on every re-render
  }, [planId, planID]);

  useEffect(() => {
    if (
      tenant &&
      tenant.senderIdentities &&
      tenant.senderIdentities.length > 0
    ) {
      // set sender the identity that has isDefault true
      const defaultSender = tenant.senderIdentities.find(
        (identity) => identity.isDefault === true
      );

      if (defaultSender) {
        setSender(defaultSender);
      }
    } else {
      setSender(null);
    }
  }, [tenant]);

  const noEmail = treatmentPlan?.patient?.email === "";
  const noAccess = !hasAccessSendToPatient;
  const nothingSelected = selectedPlans.length === 0;

  const isSendDisabled = noEmail || noAccess || nothingSelected;

  const getTooltipMessage = () => {
    if (noEmail) return t("patient.noEmail");
    if (noAccess) return t("patient.noAccessSendToPatient");
    if (nothingSelected) return t("treatmentPlan.noPlansSelected");
    return "";
  };

  // const isSendDisabled =
  //   selectedPlans.length === 0 ||
  //   (treatmentPlan &&
  //     treatmentPlan.patient &&
  //     treatmentPlan.patient.email === "");

  // console.log("successSendEmail:", successSendEmail);
  // console.log("errorSendEmail:", errorSendEmail);
  // console.log("isSending:", isSending);
  // console.log("loadingSendEmail:", loadingSendEmail);
  // console.log("treatmentPlan:", treatmentPlan);
  // console.log("planTextLanguage:", planTextLanguage);
  // console.log("tenant:", tenant);

  // console.log("hasAccessSendToPatient :", hasAccessSendToPatient);

  return (
    <>
      {addTreatmentPlanModalOpen && (
        <AddTreatmentPlanModal
          patientId={patient && patient._id}
          patientName={patient && patient.firstName + " " + patient.lastName}
          addTreatmentPlanModalOpen={addTreatmentPlanModalOpen}
          setAddTreatmentPlanModalOpen={setAddTreatmentPlanModalOpen}
          handlePlanSelect={handlePlanSelect}
          selectedPlans={selectedPlans}
        />
      )}

      {addSenderIdentitiesModalOpen && (
        <SelectSenderIdentityModal
          data={tenant && tenant.senderIdentities}
          sender={sender}
          handleSenderSelect={handleSenderSelect}
          patientId={patient && patient._id}
          addSenderIdentitiesModalOpen={addSenderIdentitiesModalOpen}
          setAddSenderIdentitiesModalOpen={setAddSenderIdentitiesModalOpen}
        />
      )}

      <Modal
        isOpen={open}
        onClose={closeHandler}
        isCentered
        autoFocus={false}
        scrollBehavior="inside"
        blockScrollOnMount={false}
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={["0rem", "1.5rem"]}
          w="100%"
          minW={["100%", "1200px"]}
          maxW={["100vw", "1200px"]}
          minH={["100%", "calc(100vh - 60px)"]}
        >
          {isSending || loadingSendEmail ? (
            <IsSending
              setOpen={setOpen}
              loadingSendEmail={loadingSendEmail}
              successSendEmail={successSendEmail}
              errorSendEmail={errorSendEmail}
              isModalSending={isModalSending}
              setIsModalSending={setIsModalSending}
              fetchUserDetails={fetchUserDetails}
              fetchUnavailable={fetchUnavailable}
              setFetchUnavailable={setFetchUnavailable}
              closeHandler={closeHandler}
              close={close}
            />
          ) : (
            <>
              <Flex
                justify="space-between"
                align="center"
                p={["1.25rem 1.5rem 1.25rem", "1.25rem 2rem 1.25rem"]}
                borderBottom={`1px solid ${newBorder}`}
                mb="0rem"
                position="relative"
                zIndex={90}
                // bg={greenText}
                w="100%"
              >
                <Flex align="center">
                  <Flex align="center">
                    <Heading
                      fontSize={["1rem", "1.125rem"]}
                      color={textPrimary}
                      fontWeight="600"
                      mr={4}
                    >
                      {t("treatmentPlan.sendTreatmentPlanModalTitle")} -{" "}
                      {planID}
                    </Heading>
                    {/* {status} */}
                  </Flex>
                </Flex>
                <IconButton
                  bg={backgroundLight}
                  border={`1px solid ${backgroundLight}`}
                  color={textSecondary}
                  icon={<FaXmark />}
                  borderRadius="10.75rem"
                  fontSize="0.875rem"
                  onClick={closeHandler}
                  _hover={{
                    bg: primaryAlt,
                    color: white,
                    border: primaryAlt,
                  }}
                />
              </Flex>

              <ModalBody
                w="100%"
                p={["1.5rem 1.5rem 1.5rem", "1.5rem 2rem 1.5rem"]}
                overflowX="hidden"
              >
                <Flex
                  w="100%"
                  justify="space-between"
                  gap={["0rem", "2rem"]}
                  direction={["column", "row"]}
                >
                  {/* LEFT START */}
                  <Flex
                    w={["100%", "40%"]}
                    h="100%"
                    minH={["100%", "580px"]}
                    position="relative"
                  >
                    <Flex
                      w="100%"
                      p="0 0"
                      direction="column"
                      h="100%"
                      minH={["100%", "580px"]}
                    >
                      <Flex direction="column" w="100%">
                        {/* PATIENT */}
                        <TreatmentPlanSendingPatient
                          treatmentPlan={treatmentPlan}
                        />

                        {/* LANGUAGE */}
                        {/* <Flex w="100%" m="0 0 1rem">
                          <FormControlLanguage
                            isBig
                            isRounded
                            label={t("treatmentPlan.languageSelect")}
                            value={planTextLanguage}
                            isRequired={false}
                            onChange={(selectedOption) =>
                              setPlanTextLanguage(selectedOption.value)
                            }
                            w={["100%", "100%", "100%"]}
                          />
                        </Flex> */}
                        {/* SENDER IDENTITY */}
                        {/* <TreatmentPlanSendingSenderIdentity
                          sender={sender}
                          onClick={() => setAddSenderIdentitiesModalOpen(true)}
                        /> */}

                        {/* LANGUAGE */}

                        {/* PATIENT PORTAL INFO */}

                        <TreatmentPlanSendingPatientPortalInfo
                          tenant={tenant}
                          treatmentPlan={treatmentPlan}
                        />
                        {/* <TreatmentPlanSendingAccessHistory /> */}
                      </Flex>

                      {/* BUTTONS */}
                      <Box
                        w="100%"
                        m={["2rem 0 0", "1rem 0 0"]}
                        position={["relative", "absolute"]}
                        left={["initial", "0"]}
                        bottom={["initial", "1.5rem"]}
                      >
                        {!isSending && !loadingSendEmail && (
                          <>
                            {/* {isSendDisabled && (
                              <Flex
                                align="center"
                                justify="flex-end"
                                p="0 0.5rem 0.5rem 0"
                              >
                                <Text
                                  fontSize="sm"
                                  fontWeight="500"
                                  textAlign="right"
                                  color={buttonRedText}
                                  mb="0.5rem"
                                >
                                  {t("patient.noEmailPleaseAdd")}
                                </Text>
                              </Flex>
                            )} */}
                            <Flex
                              align="center"
                              justify={["space-between", "flex-end"]}
                              w="100%"
                              gap={["1rem", "1rem"]}
                            >
                              <Button
                                minW={["50%", "6rem"]}
                                w={["50%", "initial"]}
                                size="lg"
                                fontSize="sm"
                                bg={backgroundLight}
                                color={textSecondary}
                                onClick={() => setOpen(false)}
                                borderRadius="10rem"
                                _hover={{ bg: primaryAlt, color: white }}
                              >
                                {t("common.cancel")}
                              </Button>

                              <Tooltip
                                p="0.5rem 1rem"
                                borderRadius="1rem"
                                placement="top"
                                label={
                                  <Flex direction="column">
                                    <Text fontSize="xs" fontWeight="500">
                                      {getTooltipMessage()}
                                    </Text>
                                  </Flex>
                                }
                                isDisabled={!isSendDisabled}
                              >
                                <Button
                                  minW={["50%", "10rem"]}
                                  w={["50%", "initial"]}
                                  size="lg"
                                  fontSize="sm"
                                  bg={textPrimary}
                                  color={white}
                                  onClick={handleSendTreatmentPlanListEmail}
                                  borderRadius="10rem"
                                  _hover={{ bg: primaryAlt, color: white }}
                                  isDisabled={isSendDisabled}
                                >
                                  {t("treatmentPlan.sendToPatientButtonLabel")}
                                </Button>
                              </Tooltip>
                            </Flex>
                          </>
                        )}
                      </Box>
                    </Flex>
                  </Flex>
                  {/* LEFT END */}

                  {/* RIGHT START */}
                  <Flex
                    w={["100%", "60%"]}
                    maxH={["100%", "calc(100vh - 200px)"]}
                    overflowY="scroll"
                    minH={["100vh", "580px"]}
                    direction="column"
                    display={["none", "flex"]}
                  >
                    <Text
                      fontSize="sm"
                      fontWeight="500"
                      color={textPrimary}
                      m="0 0 0.5rem"
                    >
                      {t("patient.emailPreview")}
                    </Text>
                    <Flex
                      w="100%"
                      direction="column"
                      bg={backgroundLight}
                      borderRadius="2rem"
                      p="2rem"
                      h="100%"
                      overflowY="auto"
                      className="customScrollbar"
                    >
                      {/* EMAIL PREVIEW */}
                      <Flex
                        direction="column"
                        bg={white}
                        p="1.5rem"
                        borderRadius="1.25rem"
                        boxShadow="0px 4px 8px rgba(0, 0, 0, 0.05)"
                      >
                        {/* CLINIC HEADER */}
                        <Box>
                          <TreatmentPlanClinicHeaderPublic tenant={tenant} />
                        </Box>
                        {/* TREATMENT PLAN HEADER */}
                        <Box>
                          <TreatmentPlanHeaderPublic
                            treatmentPlan={treatmentPlan}
                          />
                        </Box>
                        {/* TREATMENT PLAN SERVICES */}

                        <Box>
                          <Flex w="100%" p="1rem 0 1rem">
                            <TreatmentPlanServicesPublic
                              treatmentPlan={treatmentPlan}
                              currency={tenant && tenant.currency}
                            />
                          </Flex>
                        </Box>
                        {/* TREATMENT PLAN PATIENT NOTES */}
                        <Box>
                          <TreatmentPlanPreviewPatientNotes
                            notes={treatmentPlan.notes}
                          />
                        </Box>

                        {/* TREATMENT PLAN FOOTER */}
                        <Box>
                          <TreatmentPlanPreviewFooter tenant={tenant} />
                        </Box>
                      </Flex>
                    </Flex>
                  </Flex>
                  {/* RIGHT END */}
                </Flex>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default SendTreatmentPlanModalNew;
